import { render } from "./DiabetesSix.vue?vue&type=template&id=467f3b6a&scoped=true"
import script from "./DiabetesSix.vue?vue&type=script&lang=js"
export * from "./DiabetesSix.vue?vue&type=script&lang=js"

import "./DiabetesSix.vue?vue&type=style&index=0&id=467f3b6a&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467f3b6a"]])

export default __exports__